<template>
   <div class="habit-page">
        <div class="row mt-2">
            <div class="col-lg-11 col-11 mx-auto">
                <div class="card card-widget widget-user">
                <div class="widget-user-header text-white"
                                style="background: url('/assets/images/pexels-karol-d-1113839_design.png')  center;">
                                <h2 class="widget-user-desc text-left">Use your power of Choice &amp; Focus</h2>
                                <h2 class="widget-user-desc text-right">Design Version 2.0 of You.</h2>
                                <h3 class="widget-user-username text-right">Focus: For the Future Self that <u><em>you</em></u> want.</h3>
                            </div>
                            <div class="widget-user-image">
                                <img class="img-circle" src="/assets/images/pexels-anna-shvets-3727456_design128x128.png" alt="User Avatar">
                            </div>
                </div>
            </div>
        </div>

                    <div class="card p-2 m-6 bg-default">
                                <div class="row">
                                <div  class="col-md-4">
                                        <h5 v-if="!readOnly">Select your Life-Area &amp; Design it:</h5>

                                        <h5 v-if="readOnly &&  myFSDetails.length>0">Review (and Refocus on) each of your Life-Areas:
                                        <span v-if="readOnly && reviewMessage==''" style="font-size:small;color:brown;"><b>Review Time: {{ elapsedTime }}  seconds.</b><br/>(Need to spend {{elapsedTimeTarget}} seconds)</span>
                                        <span v-if="readOnly && !reviewMessage==''" style="font-size:small;color:brown;"><b>{{ reviewMessage }}</b><br/>(Need to spend at least {{elapsedTimeTarget}} seconds reviewing.)</span>
                                        </h5>
                                    </div>
                                <div v-if="!readOnly" class="col-md-3">
                                     <select class="p-2" style="margin:.5em;" @change="displayModal($event.target.value)" v-model="sel_template" >
                                        <option value="" :key="-1">Select a Life-Area</option>
                                        <option v-for="templ in unprocLifeAreas" :key="templ" :value="templ" v-html="templ"></option>
                                    </select>
                                <br/>
                                <small  v-if="!readOnly  && (unprocLifeAreas.length > 0)">(Your above Life-Areas are un-addressed).</small>
                                </div>
                                <div class="col-md-4" >
                                    <table class="table table-sm table-light table-striped small">
                                        <thead><tr><span v-if="!readOnly && myFSDetails.length>0">View my<br/>Performance Results</span></td><td><span v-if="!readOnly && (myFSDetails.length>0||grading==true)">Track/Report on<br/>my Performance</span></td><td>Back to Dash</td><td></td></tr></thead>
                                        <tbody>
                                            <tr>
                                                <td ><button v-if="!readOnly && myFSDetails.length>0" class="btn btn-sm fai-blue bg-light" title="View My Performance"  @click="viewPerfTrack"><i class="fas fa-eye fai-blue  p-2"></i></button></td>
                                                <td><button v-if="!readOnly && (myFSDetails.length>0||grading==true)" class="btn btn-sm fai-blue bg-light" title="Grade my Performance"  @click="gradeMyPerformance"> <i class="fas fa-list fai-orange p-2" ></i></button></td>
                                                <td><button class="btn btn-sm fai-blue bg-light"  title="Back to Dash"  @click="exitToDash"> <i class="fa fa-arrow-left fai-green p-2"></i></button></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                    </div>
                    <div  v-if="readOnly" class="card p-2 m-2 bg-default">
                        <div class="row d-flex justify-content-center">
                            <p v-if="myFSDetails.length>0" class="p-0"><strong>For Optimal Results:</strong>Each morning and before bed, read the Vision, Plan &amp; Measure
                                    <br/>that You have designed under each of your Life-Areas (below).</p>
                            <p v-else style="color:brown;">Note: You need to set up your Vision, Plan &amp; Measure for your Life-Areas first via the <a href="/fself/create/">Dashboard</a>.</p>
                        </div>
                    </div>

                        <div class="content-box-gray card"   v-if="grading">
                                <div class="title text-center">
                                    <h6 class="mt-2" style="margin:auto;" >Grade yourself on your performance as of today</h6></div>
                                    <div class="content">
                                        <div class="p-2">
                                        <span class="d-flex d-column justify-content-between" style="width:10em;"  v-for="aDet in myFSDetails" :key="aDet.life_area">
                                                {{aDet.life_area}}:&nbsp;
                                        <input style="width:2.5em;"  v-model="perf[aDet.life_area]" type="number" min="0" max="5" ></span>
                                        <span class="d-flex d-column justify-content-between" style="width:10em;"> </span>
                                        </div>
                                        <div class="p-2">
                                        <i class="fas fa-save fai-green p-2" title="Save my Grading"  :disabled="grading" @click="savePerf"></i>
                                        <i class="fas fa-power-off fai-red p-2" title="Close"  :disabled="grading" @click="cancelPerf"></i>
                                        </div>
                                    </div>
                                </div>

                    <div class="list-group-item">
                            <div class="row">
                                <div v-for="aDet in myFSDetails"  :key="aDet.life_area" class="col-auto col-md-4">
                                    <div class="content-box-gray card" >
                                    <div class="title text-center d-flex">
                                        <h6 class="mt-2" style="margin:auto;" v-html="aDet.life_area"></h6>
                                        <div  v-if="!readOnly" class="p-2"><i class="fas fa-trash float-right mx-2 fai-red" title="Delete" @click="doubleConfirmDeleteFSDetails(aDet.life_area)"></i>
                                        <i   v-if="!readOnly" class="fas fa-pen float-right mx-2 fai-blue" title="Update my Strategy" @click="editFSDetails(aDet.id)"></i></div>
                                    </div>
                                        <div class="content">
                                        <div class="card" style="padding:.5em;">
                                                <h4>Vision:</h4>
                                                <p v-html="aDet.vision"></p>
                                                <!-- <h4>Standards &amp; Plan:</h4><i @click="habitPopup(aDet.life_area)" class="fas fa-plus fai-red">Supporting Habit</i> -->

                                                <div class="row d-flex justify-content-between">
                                                    <h4 class="col-12">Standards &amp; Plan:</h4>
                                                    <!-- <i @click="habitPopup(aDet.life_area)" class="fas fa-plus fai-red col-6 text-right">Habit-Support</i> -->
                                                </div>
                                                <p v-html="aDet.plan"></p>
                                                <div class="row d-flex justify-content-between">
                                                <h4 class="col-12">Measure:</h4>
                                                    <!-- <i @click="myProgressPopup(aDet.life_area)" class="fas fa-eye fai-blue col-6 text-right">My Progress</i> -->
                                                </div>
                                                <p v-html="aDet.measure"></p>
                                                <div class="d-flex flex-row justify-content-end">
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>

        <future-me-life-area :userdata="userdata" :templates="alltemplates" :apikey="apikey"></future-me-life-area>
    </div>
</template>

<script>

import axios from 'axios';
// import FuturemeLifearea from './modal/FutureMeLifeArea';
import Swal from 'sweetalert2';
var _ = require('lodash');
import { v4 as uuidv4 } from 'uuid';
import FutureMeLifeArea from './modal/FutureMeLifeArea.vue';
import EventBus from '../../event-bus';
// import Modal from '../../components/global/popup/Modal.vue';


export default {
    components: {
        FutureMeLifeArea,
        // Modal,
     },
    name: "FutureMeSetup",
    data() {
        return {
            elapsedTimeTarget: 240,
            token: document.head.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            loading: false,
            errors: {
                header: '',
                hc_add: '',
            },
            alltemplates:[],
            userinfo:'',
            sel_template:'',
            myFSDetails:[],
            unprocLifeAreas:[],
            grading:false,
            perf:[],
            isModalVisible:false,
            readOnly:false,
            startTime:'',
            elapsedTime:'',
            reviewMessage:'',
            timerInterval:'',

        }
    },

    props: {
        userdata:'',
        templates:[],
        apikey:'',
        myfsdetails:[],
        readonly: false,
    },
    mounted() {
        this.userinfo = JSON.parse(this.userdata);
        this.alltemplates = JSON.parse(this.templates);
        this.myFSDetails = JSON.parse(this.myfsdetails);
        this.unprocLifeAreas = this.todoLifeAreas();
        this.initPerfArray();//sets the performance array to 0 for each lifearea.
        this.readOnly  = (this.readonly == true || this.readonly == 'true')? true:false;
        EventBus.$on('refreshParentPage', ()=> {
            console.log("RefreshParentPage called");
             location.reload()});
        if(this.myFSDetails.length > 0) {
            this.startTime = new Date();
            this.startTimer();
        }
    },

    methods: {
        startTimer() {
            this.timerInterval = setInterval(() => {
            const currentTime = new Date();
            this.elapsedTime = Math.floor(
                (currentTime - this.startTime) / 1000
            );
            }, 1000);
            console.error(this.elapsedTime);
            if(this.elapsedTime >= this.elapsedTimeTarget) {
            console.error('Review  time achieved for ' + this.userinfo.id);
                this.recordFSReview();
                this.reviewMessage ="Great job!";
                this.stopTimer();
            }
        },
        stopTimer() {
            clearInterval(this.timerInterval);
        },
        recordFSReview() {
            console.error('Recording review for ' + this.userinfo.id);
             axios.post('/fself/review/save', {
                user_id:this.userinfo.id,
            })
            .then(res => {
                this.reviewMessage = res.data.message;
                this.stopTimer();
                console.error(res.data.message);
            })
            .catch(err => {               ;
                console.error(err);
            })
            .finally(()=> {
                  this.updateToast(this.reviewMessage, 4000);
            });
        },


        habitPopup(){
            console.error("Edit/Create Habit to support Life-Area");
        },
        myProgressPopup(life_area) {
             console.error("Edit/Create Forum Thread to track Life-Area");
        },
        initPerfArray(){
            this.myFSDetails.map((myd) => { this.perf[myd.life_area] = 0;});
        },
        cancelPerf() {
            this.grading = false;
            this.initPerfArray();//discard any input.
        },
        savePerf() {
            console.log(this.perf);
            console.log(JSON.stringify(Object.assign({},this.perf)));

            axios.post('/fself/performance/save', {
                user_id:this.userinfo.id,
                perf:JSON.stringify(Object.assign({},this.perf)),
            })
            .then(res => {
                this.loading = false;
                this.success = true;
                this.message = res.data.message;
                // this.myFSDetails= JSON.parse(res.data.fsdetails);
                this.cancelPerf();
                console.error(res.data.message);
            })
            .catch(err => {
                // this.loading = false;
                // this.failure = true;
                console.error(err);
            })
            .finally(()=> {
                // location.reload();
                  this.updateToast(this.message, 4000);
                this.message = '';
            });
        },
        gradeMyPerformance() {
            this.grading = true;
        },
        exitToDash() {
            location.replace('/fself/dash')
        },
        viewPerfTrack() {
            location.replace('/fself/reportsn')
        },
        /**
        * @param {null}
        * @return {String} guid
        */
        getGUID() {
            var guid = uuidv4();
            console.log("GUID: " + guid);
            return guid;
        },
        displayModal(val) {
            if(val != '') {
                const payload = {
                life_area: val,
                }
                EventBus.$emit('populateModal', payload);
            }
        },

        displayModal2(id) {
            var model = this.getFSDetailsModel(id);
                const payload = {
                    model: model,
                }
            EventBus.$emit('populateModal2', payload);
        },
        getFSDetailsModel(id) {
            return this.myFSDetails.find((fsDet)=>{
                return fsDet.id == id;
            });
        },
        editFSDetails(id) {
            this.displayModal2(id);
        },
        todoLifeAreas() {
            var fsAreasWithout = [];
            var allLifeAreas = '';
            var myFSLifeDetailsAreas = this.myFSDetails.map((myd) => { return myd.life_area});
            //  console.log(myFSLifeDetailsAreas);
            allLifeAreas = this.alltemplates.map((templ)=>{
                // console.error(templ.life_area);
                (!myFSLifeDetailsAreas.includes(templ.life_area))? fsAreasWithout.push(templ.life_area):'';
                return templ.life_area;
            });
            // console.log(fsAreasWithout);
            // console.log(allLifeAreas);
            return fsAreasWithout;
        },
        doubleConfirmDeleteFSDetails(life_area) {
            Swal.fire({
            title: 'Do you want to delete your current ' + life_area + ' Future-Self Vision &amp; Plan?',
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: 'Delete',
            denyButtonText: `Don't delete`,
            }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
            Swal.fire('Deleting....', '', 'success');
                console.log("Deleting for user: " + this.userinfo.id + " life-area vision: "+ life_area);
                this.deleteLifeArea(this.userinfo.id, life_area);
            } else if (result.isDenied) {
            Swal.fire('The ' + life_area + ' Future-Self Vision &amp; Plan was not deleted', '', 'info')
            }
            });
        },
        deleteLifeArea(user_id, life_area){

             axios.post('/fself/components/delete', {
                user_id:user_id,
                life_area:life_area,
            })
            .then(res => {
                this.loading = false;
                this.success = true;
                this.message = res.data.message;
                this.myFSDetails= JSON.parse(res.data.fsdetails);

                console.error(res.data.message);
            })
            .catch(err => {
                // this.loading = false;
                // this.failure = true;
                console.error(err.message);

            })
            .finally(()=> {
                // location.reload();
                  this.updateToast(this.message, 4000);

            });
        },
        updateToast(message, timer = 2000, icon='success') {
            const Toast = Swal.mixin({
                position: 'center',
                width: 500,
                showConfirmButton: true,
            });
            Toast.fire({
                icon: icon,
                title: message
            });
        },

    },
    watch: {
        elapsedTime(newValue) {
            if (newValue === this.elapsedTimeTarget) {
            this.recordFSReview();
            }
        }
    },
}
</script>

<style scoped>
.fai-red{
    color:rgb(129, 67, 67);
}
.fai-green{
    color:rgb(65, 131, 65);
}
.fai-blue{
    color:#0707c0;
}
.fai-orange{
    color:#c05d07;
}
.content-box-gray .content {
    overflow:    ;
    padding: 10px;
    font-size: 1.2em;
    /* border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em; */
    border: 1px solid rgb(15, 9, 9);
    color: #212c3e;
}
.content-box-gray .title {
    height:4em;
    line-height:1.6em;
    border-top-left-radius: .5em;
    border-top-right-radius: .5em;
    background:#5fa3ca;
    font-size:.75em;
    font-family:verdana;
    display:block;
    color:white;
    display:block;
    padding:auto;
    border: 1px solid gray;
    border-bottom:none;
}

</style>
